import React from 'react'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { MarketingDrawer } from '@app/components/general'
import { SectionContainer } from '@app/components/stateless/containers/section-container'
import loadNamespaces from 'next-translate/loadNamespaces'
import { metaSetter } from '@app/utils'
import type { GetStaticProps } from 'next'
import type { I18nDictionary } from 'next-translate'
import { CalculatorProvider } from '@app/components/calculator/provider'
import { RenderCalculatorApp } from '@app/components/calculator/render'
import { RenderCalculatorIntro } from '@app/components/calculator/render-intro'
import { Link } from '@app/components/stateless/typo/link'
import { blueLink } from '@app/components/stateless/typo/link-style'

export const getStaticProps: GetStaticProps<{
  __lang: string
  __namespaces?: Record<string, I18nDictionary>
}> = async (ctx) => {
  return {
    props: await loadNamespaces({
      ...ctx,
      pathname: '/oss-accessibility-benchmarks',
    }),
  }
}

export const OSSWebAccessibilityBenchmarks = () => {
  const { lang, t } = useTranslation('oss-accessibility-benchmarks')

  return (
    <CalculatorProvider lang={lang}>
      <MarketingDrawer>
        <SectionContainer container block>
          <RenderCalculatorIntro />
          <RenderCalculatorApp />
          <div className='py-4 px-3'>
            <Link
              href='https://github.com/a11ywatch/accessibility-calculator'
              className={blueLink}
              target={'_blank'}
              rel='noopener noreferrer'
            >
              {t('view-source')}
            </Link>
          </div>
        </SectionContainer>
      </MarketingDrawer>
    </CalculatorProvider>
  )
}

export default metaSetter(
  { OSSWebAccessibilityBenchmarks },
  {
    translation: 'oss-accessibility-benchmarks',
  }
)
